import type { ComponentChildren } from 'preact';
import { NAV_GROUPS } from './navItems';

// The shared cockpit chrome: stationary left rail (brand + nav + side cards +
// lock slot) and the workspace slot. Markup + classes mirror approved-cockpit.js
// shell()/sidebar()/nav() so the existing CSS gives byte-level visual parity.
// State-driven (Preact) instead of innerHTML-replace.
export function Shell({ active, children }: { active: string; children: ComponentChildren }) {
  return (
    <div class="om-cockpit">
      <aside class="om-left-rail">
        <a class="om-brand" href="/">
          <img src="/brand/ordo-logo.png" alt="Ordo Mentis Apathetic Eye" />
          <span class="om-brand-title">Ordo Mentis</span>
          <span class="om-brand-sub">Veritas - Ratio - Disciplina</span>
        </a>
        <nav class="om-nav-list" aria-label="Primary">
          {NAV_GROUPS.map((group) => (
            <div class="om-nav-group" key={group.title || 'top'}>
              {group.title ? <div class="om-nav-group-title">{group.title}</div> : null}
              {group.items.map((item) => (
                <a class={item.label === active ? 'active' : ''} href={item.href}>
                  <span class="om-nav-ico">{item.icon}</span>
                  <span>{item.label}</span>
                </a>
              ))}
            </div>
          ))}
        </nav>
        <section class="om-side-card om-glass">
          <h3>Paper Portfolio</h3>
          <p>Starting Capital (default seed)</p>
          <div class="om-money">$100,000</div>
          <p>Across 2 Accounts</p>
          <p class="om-good">Paper only</p>
          <a class="om-btn" href="/portfolio">View Paper Portfolio</a>
        </section>
        <section class="om-side-card om-glass om-user-row">
          <span class="om-avatar-round">M</span>
          <span>
            <strong>M. Golden</strong>
            <br />
            <span class="om-muted">Pro Plan</span>
          </span>
          <span>v</span>
        </section>
        {/* The Oculus-Clipeus gate (datahub-client.js) docks its persistent lock
            pill here via showLockControl() after sign-in. */}
        <div id="omLockSlot" class="om-lock-slot" />
        {/* No hardcoded version string here — the old "v4.0.0-beta (rebuild)"
            sat stale for months (stale-data audit 2026-07-05). */}
        <footer class="om-muted">Trader Suite — research &amp; paper by default</footer>
      </aside>
      <main class="om-workspace">{children}</main>
    </div>
  );
}
